var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardAppliedJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20215 5.45692V3.61506C6.20215 2.88201 6.80193 2.28223 7.53498 2.28223H14.4658C15.1989 2.28223 15.7986 2.88201 15.7986 3.61506V5.45692",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8584 11.4551V18.4766C1.8584 19.1591 2.41694 19.7176 3.09932 19.7176H8.25",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30886 13.3071C3.81859 12.8292 1.03125 11.6429 1.03125 9.74796V6.81124C1.03125 6.12778 1.58867 5.57031 2.27217 5.57031H19.7278C20.4113 5.57031 20.9688 6.12782 20.9688 6.81124L21.2635 8.40952",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9692 14.5749C20.9692 17.4112 18.67 19.7104 15.8337 19.7104C12.9975 19.7104 10.6982 17.4112 10.6982 14.5749C10.6982 11.7387 12.9975 9.43945 15.8337 9.43945C18.67 9.43945 20.9692 11.7387 20.9692 14.5749Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.906 13.1709L15.0983 15.9786L13.7617 14.642",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAppliedJobs);
export default __webpack_public_path__ + "static/media/dashboard-applied-jobs.1a46f06131f9274160dddd58de511de3.svg";
export { ForwardRef as ReactComponent };